var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVirtual(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_cup",
    "data-name": "vuesax/bulk/cup",
    transform: "translate(-364 -380)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.75,4.54h-1V4.29a2.006,2.006,0,0,0-2-2H7.5V0a6.282,6.282,0,0,1-.75.04A6.282,6.282,0,0,1,6,0V2.29H3.75a2.006,2.006,0,0,0-2,2v.25h-1a.75.75,0,0,0,0,1.5h12a.75.75,0,0,0,0-1.5Z",
    transform: "translate(369.25 395.96)",
    fill: "#3896d5",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M3.24,7.39a4.892,4.892,0,0,1-1.7-1.12A5.459,5.459,0,0,1,0,2.57,2.544,2.544,0,0,1,2.57,0h.56a3.953,3.953,0,0,0-.41,1.75v3A6.793,6.793,0,0,0,3.24,7.39Z",
    transform: "translate(366.28 384.25)",
    fill: "#3896d5",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M3.24,2.57A5.459,5.459,0,0,1,1.7,6.27,4.892,4.892,0,0,1,0,7.39,6.793,6.793,0,0,0,.52,4.75v-3A3.953,3.953,0,0,0,.11,0H.67A2.544,2.544,0,0,1,3.24,2.57Z",
    transform: "translate(382.48 384.25)",
    fill: "#3896d5",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M10,0H4A4,4,0,0,0,0,4V7A7,7,0,0,0,14,7V4A4,4,0,0,0,10,0ZM9.84,6.45l-.62.76a.751.751,0,0,0-.16.48l.06.98a.643.643,0,0,1-.95.69L7.26,9a.92.92,0,0,0-.52,0l-.91.36a.643.643,0,0,1-.95-.69l.06-.98a.751.751,0,0,0-.16-.48l-.62-.76a.644.644,0,0,1,.36-1.12l.95-.24a.794.794,0,0,0,.41-.31l.53-.82a.646.646,0,0,1,1.18,0l.53.82a.794.794,0,0,0,.41.31l.95.24A.644.644,0,0,1,9.84,6.45Z",
    transform: "translate(369 382)",
    fill: "#3896d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M5.891,2.872l-.62.76a.751.751,0,0,0-.16.48l.06.98a.643.643,0,0,1-.95.69l-.91-.36a.92.92,0,0,0-.52,0l-.91.36a.643.643,0,0,1-.95-.69l.06-.98a.751.751,0,0,0-.16-.48l-.62-.76a.644.644,0,0,1,.36-1.12l.95-.24a.794.794,0,0,0,.41-.31l.53-.82a.646.646,0,0,1,1.18,0l.53.82a.794.794,0,0,0,.41.31l.95.24A.644.644,0,0,1,5.891,2.872Z",
    transform: "translate(372.949 385.578)",
    fill: "#3896d5",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(364 380)",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtual);
export default __webpack_public_path__ + "static/media/virtual.5ba96b26e99fab76a5abec2c3e344876.svg";
export { ForwardRef as ReactComponent };